module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/RewardItem/images/industrial_resource_small.94391564.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/RewardItem/images/industrial_resource_small.png
// module id = 2944
// module chunks = 11